/****************************************************
 * Module Name:  workerMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import WorkerProxy from "../../utility/proxy/worker/workerProxy";
import AddWorkerModal from "./addWorkerModal";
import Utility from "../../utility/utility";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class WorkerMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      workers: [],
      showAddWorkerModal: false,
      editOperation: false,
      sourceData: {},
      loadingButton: false,
      accesDenied: false,
      errorSnackbar: false,
      showWorkerLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid === Constants.PERMISSIONS.WORKER
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("WORKER");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchWorkerData(false);
    }
  }

  fetchWorkerData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showWorkerLoadSpinner: true });
    WorkerProxy.GetAllWorker((responseData) => {
      if (responseData) {
        this.setState({ workers: responseData, showWorkerLoadSpinner: false })
      } else {
        this.setState({ errorSnackbar: true, showWorkerLoadSpinner: false })

      }
    }
    );
  };

  columns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: "name",
      headerName: "WORKER",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 2,
      renderCell: renderCellExpand,
    },
    {
      field: "occurs",
      headerName: "OCCURS",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: ['MULTIPLE', 'ONCE'],
      filterOperators: Utility.combinedFilters(),
      flex: 1,
    },
    {
      field: "every",
      headerName: "EVERY (Seconds)",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      flex: 1,
    },
    {
      field: "last_schedule_time",
      headerName: "LAST SCHEDULED",
      headerAlign: "center",
      align: "center",
      flex: 2,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "next_schedule_time",
      headerName: "NEXT SCHEDULED",
      headerAlign: "center",
      align: "center",
      flex: 2,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "class_name",
      headerName: "CLASS NAME",
      headerAlign: "center",
      align: "center",
      minWidth: 300,
      renderCell: renderCellExpand,
    },
    {
      field: "deleted",
      headerName: "DELETED",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      sortable: false,
      type: "boolean",
      renderCell: (params) => {
        return params.value === false ? (
          <Box>
            <PersonIcon color="success" />
          </Box>
        ) : (
          <Box>
            <PersonOffIcon color="error" />
          </Box>
        );
      },
    },
    {
      field: "disabled",
      headerName: "DISABLED",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      sortable: false,
      type: "boolean",
      renderCell: (params) => {
        return params.value === false ? (
          <Box>
            <PersonIcon color="success" />
          </Box>
        ) : (
          <Box>
            <PersonOutlineOutlinedIcon color="error" />
          </Box>
        );
      },
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddWorkerModal: true,
                editOperation: true,
                sourceData: params.row,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideAddWorkerModal = () => {
    this.setState({
      showAddWorkerModal: false,
    });
  };

  handleValidation = (workerData) => {
    //TODO do validation if needed here
    return true;
  };

  addWorker = (workerData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Worker, and once worker is updated on call refresh the list of current workers
      WorkerProxy.UpdateWorker(workerData, (response) => {
        if (response) {
          this.fetchWorkerData(true);
          this.setState({ loadingButton: false });
          //Hidding worker modal
          this.hideAddWorkerModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    } else {
      //Creating new Worker, and once worker is created on call refresh the list of current workers
      WorkerProxy.AddWorker(workerData, (response) => {
        if (response) {
          this.fetchWorkerData(true);
          this.setState({ loadingButton: false });
          //Hidding worker modal
          this.hideAddWorkerModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
          {this.state.showWorkerLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchWorkerData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Worker">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddWorkerModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Worker
              </Button>
            </Tooltip>
          ) : null}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.workers;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");
    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />
        {this.state.showAddWorkerModal ? (
          <AddWorkerModal
            Show={true}
            handleClose={this.hideAddWorkerModal}
            handleSave={this.addWorker}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              loading={this.state.showWorkerLoadSpinner}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box >
    );
  }
}

export default WorkerMaster;
